import { render, staticRenderFns } from "./Comissionamentos.vue?vue&type=template&id=99d40c5a"
import script from "./Comissionamentos.vue?vue&type=script&lang=js"
export * from "./Comissionamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports